import React from 'react';
import {Header, Titulo} from '../elementos/Header'
import FormularioVisita from './FormularioVisita'

const RegistroVisitaDirecta = () => {
    return (
        <>
            <Header>
                    <Titulo>Registro de las personas que visitan el museo</Titulo>
            </Header>

            <FormularioVisita />
        </>
    );
}
 
export default RegistroVisitaDirecta;